import React from "react";
import logo from './loho.png';

const Stopka = () => {
    return (
        <footer className="bg-[#0a0a0a] border-t border-white/10">
            <div className="w-full max-w-screen-xl mx-auto px-4 py-12">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-8">
                    <div className="flex items-center gap-4">
                        <img src={logo} className="h-16 w-16 opacity-80" alt="Logo Teatr Łątek" />
                        <div>
                            <p className="text-white font-semibold tracking-widest text-sm uppercase">Teatr Łątek</p>
                            <p className="text-gray-500 text-xs mt-1">Supraśl, Posterunkowa 1/4</p>
                        </div>
                    </div>
                    <div className="text-sm text-gray-500 space-y-2">
                        <p>
                            Email:{" "}
                            <a href="mailto:zemlo@wp.pl" className="text-gray-300 hover:text-red-400 transition-colors">
                                zemlo@wp.pl
                            </a>
                        </p>
                        <p>
                            Telefon:{" "}
                            <a href="tel:+48503728429" className="text-gray-300 hover:text-red-400 transition-colors">
                                +48 503 728 429
                            </a>
                        </p>
                        <p>
                            Facebook:{" "}
                            <a href="https://www.facebook.com/teatrlatek/" className="text-gray-300 hover:text-red-400 transition-colors">
                                Teatr Łątek
                            </a>
                        </p>
                        <p>
                            Instagram:{" "}
                            <a href="https://www.instagram.com/teatrlatek.pl/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-red-400 transition-colors">
                                @teatrlatek.pl
                            </a>
                        </p>
                    </div>
                </div>
                <hr className="my-8 border-white/5" />
                <p className="text-xs text-gray-600 text-center tracking-wider">
                    © 2023 Teatr Łątek. Wszelkie prawa zastrzeżone.
                </p>
            </div>
        </footer>
    );
};

export default Stopka;
